import type { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { Validators } from '@angular/forms';

import { WEB_CONFIG } from '../../templates/web/web-config';
import { GlobalFormBase } from '../global-form';
import { SharedModule } from '../shared.module';

@Component({
  selector: 'app-footer',
  imports: [SharedModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent extends GlobalFormBase implements OnInit {
  public currentYear: number = new Date().getFullYear();
  override apiSlug: string = WEB_CONFIG.subscribeNewsletters;

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      email: [null, [Validators.required, Validators.email]],
    });
  }

  onPrivacyPolicy(): void {
    this.router.navigateByUrl('/privacy-policy');
  }

  onTermsAndConditions(): void {
    this.router.navigateByUrl('/terms-and-condition');
  }

  onContactUs(): void {
    this.router.navigateByUrl('/contact-us');
  }

  onNavigateToSection(fragment: string): void {
    if (this.router.url.startsWith('/')) {
      this.router.navigate(['/'], { fragment });
    } else {
      this.router.navigate(['/'], { fragment });
    }
  }

  override afterSuccessfullyAdd(): void {
    this.form.reset();
  }
}
